import { VFC } from 'react'
import { MemberPageWrapper } from 'src/components/PageWrapper'
import { Recommendations } from 'src/compositions/MyPage/Recommendations'
import { LoginUser, RecommendedUser } from 'src/models/User'
import styled from 'styled-components'

type RecommendContentProps = {
  user: LoginUser
  recommendedUsers: RecommendedUser[]
}
type RecommendLayoutProps = RecommendContentProps
export const RecommendLayout: VFC<RecommendLayoutProps> = (props) => {
  const { user } = props
  return (
    <>
      <RecommendWrapper user={user} currentPath="今日のAIピック">
        <RecommendContent {...props} />
      </RecommendWrapper>
    </>
  )
}

const RecommendContent: VFC<RecommendContentProps> = ({
  user,
  recommendedUsers,
}) => {
  return (
    <Recommendations
      recommendedUsers={recommendedUsers}
      showTips={user.plan.paid || user.plan.isAdminRole}
    />
  )
}
const RecommendWrapper = styled(MemberPageWrapper)`
  padding-top: 150px;
`
